import { Box, IconButton, Tooltip, Chip } from "@mui/joy";
import { Info as InfoIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function Info(props: any) {
    const navigate = useNavigate();
    const { value } = props;

    const handleClick = () => {
        navigate(`/admin/users/edit/${value}`);
    };

    return (
        <Box display={"flex"} justifyContent={"center"} alignItems={"center"} height={"100%"}>
            <Tooltip title="Manage roles" placement="top">
                <IconButton
                    size="sm"
                    variant="soft"
                    color="primary"
                    onClick={handleClick}
                    sx={{ "--IconButton-size": "32px" }}
                >
                    <InfoIcon size={16} />
                </IconButton>
            </Tooltip>
        </Box>
    );
}

export function RolesCellRenderer(props: any) {
    const roleNames = (props.value as string) || "";

    if (!roleNames.trim()) {
        return (
            <Box display="flex" alignItems="center" height="100%">
                <Chip size="sm" variant="soft" color="neutral">
                    No roles
                </Chip>
            </Box>
        );
    }

    return (
        <Box display="flex" alignItems="center" gap={0.5} height="100%" flexWrap="wrap" py={0.5}>
            {roleNames.split(",").map((name) => (
                <Chip key={name.trim()} size="sm" variant="soft" color="primary">
                    {name.trim()}
                </Chip>
            ))}
        </Box>
    );
}
